/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Node } from '../../../core/models/Node';
import { IExample } from '../../../core/models/common/IExample';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas20Visitor } from '../visitors/IOas20Visitor';

/**
 * Constructor.
 * @class
 * @extends Node
 * @author eric.wittmann@gmail.com
 */
export class Oas20Example extends Node implements IExample {
    /*private*/ items : any;

    public constructor() {
        super();
        this.items = <any>({});
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas20Visitor = <IOas20Visitor><any>visitor;
        viz.visitExample(this);
    }

    /**
     * Returns an array of all the example content types.
     * @return {string[]}
     */
    public getExampleContentTypes() : Array<string> {
        let rval : Array<string> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* keySet */Object.keys(this.items));
        return rval;
    }

    /**
     * Gets a single example.
     * @param {string} contentType
     * @return {*}
     */
    public getExample(contentType : string) : any {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.items, contentType);
    }

    /**
     * Adds an example.
     * @param {string} contentType
     * @param {*} example
     */
    public addExample(contentType : string, example : any) {
        /* put */(this.items[contentType] = example);
    }

    /**
     * Removes a single example.
     * @param {string} contentType
     * @return {*}
     */
    public removeExample(contentType : string) : any {
        return /* remove */(map => { let deleted = this.items[contentType];delete this.items[contentType];return deleted;})(this.items);
    }

    /**
     * Gets the examples.
     * @return {*[]}
     */
    public getExamples() : Array<any> {
        let rval : Array<any> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.items));
        return rval;
    }
}
Oas20Example["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Example";
Oas20Example["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.IExample"];




